<template>
    <div class="page_border">
    </div>
</template>
<script type="text/javascript">
    export default {
        data(){
            return {
                page: 'index'
            }
        },
        components: {
        },
        created() {
            console.log(this.isMobile(),233)
            if(this.isMobile()) {
                this.$router.push({path: '/stepMoOne',query: {service: localStorage.services}})
            } else {
                this.$router.push({path: '/stepOne',query: {service: localStorage.services}})
            }
        },
        methods: {
            isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                return flag;
            }
        },
        mounted(){
        }
    }
</script>

<style>
    body{
        background: #fff;
    }
    .index{
        background:#ffffff;
    }
    .right_icon{
        float: right;
        height: 50px;
        padding-right: 8px;
    }
    .page_border{
        padding: 4px;
    }
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        border: 1px solid #eee;
    }
    .mint-step--horizontal:last-child{
        right: 0!important;
    }
    .mint-step--horizontal:last-child .mint-step__circle-container{
        left: 0!important;
    }
    .mint-step{
        width: 25%!important;
        flex: none!important;
    }
    .mint-step--horizontal:first-child .mint-step__title{
        transform: translate3d(-30%,0,0) !important;
    }
    .mint-step--horizontal .mint-step__title{
        transform: translate3d(-30%,0,0) !important;
    }
    .mint-step--horizontal:last-child .mint-step__title{
        transform: translate3d(-20%,0,0) !important;
    }
    .mint-steps--horizontal .mint-steps__items{
        padding-left: 30px;
    }
</style>



// WEBPACK FOOTER //
// index.vue?7e579548